import Vue from 'vue'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import App from './App'
import router from './router/index'
import './service/filter'
import storage from './service/storage-service'
import resource from './service/resource-service'
Vue.prototype.storage = storage
import wx from './service/wx-service'
import getDate from './assets/utils/time'
Vue.prototype.wx = wx
Vue.config.productionTip = false
Vue.prototype.http = {
  resource: resource,
}
console.log(router)
Vue.prototype.baseImgURL = 'http://jiudaifu-jiuyou.oss-cn-hangzhou.aliyuncs.com/'
// Vue.prototype.baseImgURL = 'http://192.168.0.157:8080/jdf'
import './assets/css/style.css'

// import 'ant-design-vue/dist/antd.css'
import {
  message,
} from 'ant-design-vue'
import 'vant/lib/index.css';
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 1,
    inline: false,
    button: true,
    navbar: false,
    title: false,
    toolbar: false,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: false,
    scalable: false,
    transition: true,
    fullscreen: true,
    keyboard: false,
    loop: false,
  },
})
import {
  Icon,
  Tabbar,
  TabbarItem,
  Swipe,
  SwipeItem,
  Lazyload,
  Tab,
  Tabs,
  Checkbox,
  CheckboxGroup,
  Rate,
  Cell,
  CellGroup,
  Switch,
  Popup,
  Radio,
  RadioGroup,
  Area,
  Progress,
  Calendar,
  Uploader,
  Picker,
  List,
  Dialog,
  Toast,
  ActionSheet,
  Tag
} from 'vant';
Vue.use(Icon);
Vue.use(Tag);
Vue.use(ActionSheet);
Vue.use(Toast);
Vue.use(Area);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Popup);
Vue.use(Switch);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Rate);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Lazyload);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Progress);
Vue.use(Calendar);
Vue.use(Uploader);
Vue.use(Picker);
Vue.use(List);
Vue.use(Dialog);

import 'ant-design-vue/lib/message/style/css'
import 'ant-design-vue/lib/modal/style/css'
import 'ant-design-vue/lib/drawer/style/css'
import 'ant-design-vue/lib/upload/style/css'
import 'ant-design-vue/lib/button/style/css'
import 'ant-design-vue/lib/icon/style/css'
import 'ant-design-vue/lib/popconfirm/style/css'
import Vuex from 'vuex'
Vue.use(Vuex)
var store = new Vuex.Store({
  state: {
    recruitScrollY: 0
  },
  getters: {
    recruitScrollY: state => state.recruitScrollY
  },
  mutations: {
    changeRecruitScrollY(state, recruitScrollY) {
      state.recruitScrollY = recruitScrollY
    }
  },
  actions: {

  },
  modules: {}
})
Vue.prototype.$store = store
Vue.prototype.$message = message
Vue.prototype.time = getDate

new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js